import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Reusable Textarea component
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.error - Error message
 */
export const Textarea = React.forwardRef(({ className, error, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full px-4 py-3 border rounded-lg transition-all resize-none',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
        'disabled:bg-gray-100 disabled:cursor-not-allowed',
        error ? 'border-red-500' : 'border-gray-300',
        className
      )}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';
